import { ActivatedRoute } from "@angular/router";
import { nanoid } from 'nanoid';
import { ExternalData } from "libs-frontend-external-data/dist/js/external-data.js";
import { AppHelperService } from '../../app/services/app-helper.service';
import { OsDetect } from 'libs-frontend-micro-base';
import { Injectable } from '@angular/core';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';

// declare global {
//   interface Window { XAPIRunner: any; }
// }
// window.XAPIRunner = XAPIRunner;

@Injectable()
export class TrackUserService {

    CONSTANTS = {
        FEATURE: 'user-sessions',
        EVENT_ACTIONS: {
            START: 'START',
        },
        EVENT_CATEGORIES: {
            CONTENT_VIEWED: 'CUSTOM_SESSION_CONTENT_VIEWED'
        },
        EVENT_CATEGORY_TYPES: {
            SESSION: 'session'
        },
        EVENT_TYPES: {
            LEARNING: 'learning',
            SYSTEM: 'system'
        },
        VERBS: {
            NAVIGATED: 'navigated'
        },
        NAVIGATED_PAGE_NAMES: {
            NLP_TOC: 'nlp-toc',
            NLP_ACTIVITY: 'nlp-activity'
        }
    }

    externalDataInstance;

    constructor(
        private apiGatewayHelperService: ApiGatewayHelperService,
        private appHelperService: AppHelperService,
        private route: ActivatedRoute
    ) {
        const routePrefix = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
        const serverRoutePrefix = routePrefix.substr(0, routePrefix.length - 1);
        const options = {
            retryCallback: this.retryCallback,
            serverRoutePrefix
        };
        this.externalDataInstance = new ExternalData(options);
    }

    generateProductViewedEvent(userData) {
        return {
            "data": {
                "actorid": userData.user.extUserId,
                "os": this._getOS(),
                "timestamp": Date.now(),
                "verb": this.CONSTANTS.VERBS.NAVIGATED,
                "xapi": false,
                "user_role": userData.user.role,
                "navigated": {
                    "to": {
                        "page": userData.page,
                        "url": window.location.href
                    }
                },
                "ua": navigator.userAgent,
                "vw": this._getViewPortWidth(),
                "vh": this._getViewPortHeight(),
                ...(userData.orgId && { "org": userData.orgId }),
                ...(userData.spaceId && { "spaceId": userData.spaceId }),
                ...(userData.productCode && { "product_code": userData.productCode }),
                ...(userData.classId && { "class_id": userData.classId }),
                ...(userData.assignmentId && { "assignment_id": userData.assignmentId }),
                ...(userData.itemId && { "item_id": userData.itemId })
            },
            "action": this.CONSTANTS.EVENT_ACTIONS.START,
            "category": this.CONSTANTS.EVENT_CATEGORIES.CONTENT_VIEWED,
            "type": this.CONSTANTS.EVENT_TYPES.LEARNING,
            "originatorid": userData.user.extUserId
        }
    }

    logEvents(eventsArray) {
        const sanitizedData = this._sanitizeEventsData(eventsArray);
        return navigator.sendBeacon ? this.externalDataInstance.sendBeacon(sanitizedData) : this.externalDataInstance.postData(sanitizedData, null, { csrfToken: this._getCsrfToken() });
    }

    _sanitizeEventsData(eventsArray) {

        let sanitizedData = {
            feature: this.CONSTANTS.FEATURE,
            data: []
        }

        for (const content of eventsArray) {

            if (!content.category) continue;

            const id = this._getUniqueId();

            sanitizedData.data.push({
                id,
                content,
                opts: {
                    'folder-structure': this._getFolderPath(content)
                }
            });
        }

        return sanitizedData;
    }

    _getUniqueId() {
        return nanoid(16);
    }

    _getOS() {
        return new OsDetect().getOsName;
    }

    _getViewPortWidth() {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    }

    _getViewPortHeight() {
        return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    }

    _getDate(timestamp) {
        timestamp = timestamp || Date.now();
        const nowDate = new Date(timestamp);
        return nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + nowDate.getDate();
    }

    _getCsrfToken() {
        return this.appHelperService.getCookie('csrf-token');
    }

    _getFolderPath(content) {
        return `${content.data.actorid}/${this._getDate(content.data.timestamp)}/${content.category}`;
    }

    retryCallback(retryCount, error) {
        console.log('retryCount', retryCount);
        console.log(error);
    }

} 